import { logParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export enum CompanyLogRouteName {
    Index = 'company.logs.index',
    Show = 'company.logs.show',
}

export default {
    path: 'logs',
    name: CompanyLogRouteName.Index,
    component: () => import('@/views/company/log/Index.vue'),
    meta: {
        label: 'Company Logs',
        auth: true,
        permission: Permission.EventViewAny,
    },
    children: [
        {
            path: `:${logParamKey}`,
            name: CompanyLogRouteName.Show,
            component: () => import('@/views/company/log/Index.vue'),
            meta: {
                label: 'Secret Details',
                auth: true,
                permission: Permission.EventView,
            },
        },
    ],
}
